import {
  MINISTRY_NAME_LONG as MinistryNameLong,
  MINISTRY_NAME_SHORT as MinistryNameShort,
} from '@govalta-emu/alss-common';

export const MINISTRY_NAME_LONG = MinistryNameLong;
export const MINISTRY_NAME_SHORT = MinistryNameShort;
